const actions = {
  SEARCH_REQUEST: "GALLERY_CONTENT/SEARCH_REQUEST",
  SEARCH_SUCCESS: "GALLERY_CONTENT/SEARCH_SUCCESS",
  SEARCH_ERROR: "GALLERY_CONTENT/SEARCH_ERROR",

  REGISTER_REQUEST: "GALLERY_CONTENT/REGISTER_REQUEST",
  REGISTER_SUCCESS: "GALLERY_CONTENT/REGISTER_SUCCESS",
  REGISTER_ERROR: "GALLERY_CONTENT/REGISTER_ERROR",

  DETAIL_REQUEST: "GALLERY_CONTENT/DETAIL_REQUEST",
  DETAIL_SUCCESS: "GALLERY_CONTENT/DETAIL_SUCCESS",
  DETAIL_ERROR: "GALLERY_CONTENT/DETAIL_ERROR",

  UPDATE_REQUEST: "GALLERY_CONTENT/UPDATE_REQUEST",
  UPDATE_SUCCESS: "GALLERY_CONTENT/UPDATE_SUCCESS",
  UPDATE_ERROR: "GALLERY_CONTENT/UPDATE_ERROR",

  DELETE_REQUEST: "GALLERY_CONTENT/DELETE_REQUEST",
  DELETE_SUCCESS: "GALLERY_CONTENT/DELETE_SUCCESS",
  DELETE_ERROR: "GALLERY_CONTENT/DELETE_ERROR",

  RESET_DETAIL: "GALLERY_CONTENT/RESET_DETAIL",

  search: (payload) => ({
    type: actions.SEARCH_REQUEST,
    payload,
  }),

  register: (payload) => ({
    type: actions.REGISTER_REQUEST,
    payload,
  }),

  getDetail: (payload) => ({
    type: actions.DETAIL_REQUEST,
    payload,
  }),

  update: (payload) => ({
    type: actions.UPDATE_REQUEST,
    payload,
  }),

  delete: (payload) => ({
    type: actions.DELETE_REQUEST,
    payload,
  }),

  resetDetail: () => ({
    type: actions.RESET_DETAIL,
  }),
};

export default actions;
